import { DataPartHelper } from './data-part-helper';

interface AgentPlanPartBlockProps {
  data: unknown;
}

/** The builder's plan for the turn: a title, what it intends, and its steps in order. */
export function AgentPlanPartBlock({ data }: AgentPlanPartBlockProps) {
  const plan = DataPartHelper.getAgentPlan(data);
  if (!plan) return null;

  return (
    <div className="flex w-full flex-col gap-sm rounded-2xl border-[0.5px] border-border-tertiary bg-bg-light p-xl">
      <span className="txt-small-medium text-text-primary">{plan.title}</span>
      {plan.description && (
        <span className="txt-small-regular text-text-secondary">
          {plan.description}
        </span>
      )}
      {plan.steps.length > 0 && (
        <ol className="flex list-decimal flex-col gap-xs pl-xl txt-small-regular text-text-primary">
          {plan.steps.map((step) => (
            <li key={step.id}>{step.description}</li>
          ))}
        </ol>
      )}
    </div>
  );
}
